<template>
  <footer class="text-gray-300" :class="temaA2 ? 'footer-tema' : 'bg-gray-900'">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <CompanyInfo />
        <ContactInfo />
        <QuickLinks />
        <LegalInfo />
      </div>
      <Copyright />
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { ROTAS_VISUAL_NOVO } from '../i18n/idioma'
import CompanyInfo from './footer/CompanyInfo.vue'
import ContactInfo from './footer/ContactInfo.vue'
import QuickLinks from './footer/QuickLinks.vue'
import LegalInfo from './footer/LegalInfo.vue'
import Copyright from './footer/Copyright.vue'

const route = useRoute()
const temaA2 = computed(() => ROTAS_VISUAL_NOVO.includes(route.path))
</script>

<style>
/* Rodapé fica escuro nos dois temas, no tom das páginas do A2 */
.footer-tema {
  background: #04060d;
  border-top: 1px solid rgba(124, 145, 255, 0.16);
}
</style>